module.exports = __webpack_public_path__ + "img/bgd1.6bec05fa.svg";